import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';

import { type TipsAction, Actions as TipsActions } from './actions';

export const updateTipsSuccess = (): TipsAction => ({
  type: TipsActions.TIPS_UPDATE_SUCCESS,
});

export const updateTipsFailure = (error: ApolloError): TipsAction => ({
  type: TipsActions.TIPS_UPDATE_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});
